import { Pipe, PipeTransform } from '@angular/core';
import { FontUnit } from '../to-font-size/to-font-size.pipe';

const baseFont = 16;
const baseScreenWidth = 1600;
const baseScreenHeight = 1000;

@Pipe({
  name: 'convertToUnit',
})
export class ConvertToUnitPipe implements PipeTransform {
  transform(
    value: number,
    from: FontUnit = 'pt',
    to: FontUnit = 'rem'
  ): number {
    switch (from) {
      case 'rem':
        return this.convertRemTo(value, to);
      case 'pt':
        return this.convertPtTo(value, to);
      case 'px':
        return this.convertPxTo(value, to);
      case 'vw':
      case 'vh':
        return this.convertPxTo(value, to);
    }
  }

  convertRemTo(rem: number, to: FontUnit): number {
    switch (to) {
      case 'rem':
        return rem;
      case 'pt':
        return this.convertPxTo(rem * baseFont, 'pt');
      case 'px':
        return rem * baseFont;
      case 'vw':
        return (rem * baseFont) / baseScreenWidth;
      case 'vh':
        return (rem * baseFont) / baseScreenHeight;
    }
  }

  convertPxTo(px: number, to: FontUnit): number {
    switch (to) {
      case 'rem':
        return px / baseFont;
      case 'pt':
        return (72 / 96) * px;
      case 'px':
        return px;
      case 'vw':
        return (px / baseScreenWidth) * 100;
      case 'vh':
        return (px / baseScreenHeight) * 100;
    }
  }

  convertPtTo(pt: number, to: FontUnit): number {
    switch (to) {
      case 'rem':
        return this.convertPxTo(pt / (72 / 96), 'rem');
      case 'pt':
        return pt;
      case 'px':
        return pt / (72 / 96);
      case 'vw':
        return ((pt * 1.3333343412075) / baseScreenWidth) * 100;
      case 'vh':
        return ((pt * 1.3333343412075) / baseScreenHeight) * 100;
    }
  }
}
